import { Email, Phone } from '@mui/icons-material';
import { Grid, Typography, Divider, Box } from '@mui/material';
import { t } from 'i18next';
import { MemberDetail } from 'src/modules/member/components/memberDetail';
import { MemberDetailLink } from 'src/modules/member/components/memberDetailLink';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { formatDate } from 'src/shared/functions/formatDate';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';
import { Link } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';
import { Invoice } from '../models/invoice';
import { InvoiceRowsTable } from './invoiceRowsTable';

type InvoiceDetailSummaryProps = {
  invoice: Invoice;
};

export const InvoiceDetailSummary = (props: InvoiceDetailSummaryProps) => {
  const { invoice } = props;
  const { currentUser } = useGlobals();
  const otherLabel = getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.OtherLabel, 'member:otherContact.label');

  const DetailItem = ({ label, value }: { label: string; value: any }) => (
    <Box mb={2}>
      <Typography sx={{ fontWeight: 600, fontSize: 16 }} variant='h6'>
        {label}
      </Typography>
      <Typography variant='h6' sx={{ fontWeight: 400, fontSize: 16 }}>
        {value}
      </Typography>
    </Box>
  );

  return (
    <ContentSection transparentBackground>
      {/* {!loading && invoice && (
      // Kommenterar ut denna enligt KH 2023-04-14
      <Button
        size='small'
        variant='outlined'
        onClick={onActivateEditInvoice}
        endIcon={<Edit />}
        sx={{ position: 'absolute', top: '1rem', right: '1rem' }}
        disabled
      >
        {t('common:button.edit')}
      </Button>
    )} */}
      <GridWrapper>
        <Grid item xs={12}>
          <Typography variant='h4' sx={{ fontWeight: 600 }}>
            <AmountWithCurrency amount={invoice.amount} />
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <DetailItem label='OCR:' value={invoice.ocr} />
          <DetailItem label={`${t('invoice:dueDate')}:`} value={formatDate(invoice.dueDate)} />
          <DetailItem label={`${t('invoice:invoiceMissionPage.created')}:`} value={formatDate(invoice.created)} />
        </Grid>
        <Grid item xs={3}>
          <DetailItem label={`${t('invoice:InvoiceType')}:`} value={invoice.category?.text ?? '-'} />
          {/* <DetailItem label={`${t('invoice:dueDate')}:`} value={formatDate(invoice.dueDate)} /> */}
        </Grid>
        <Grid item xs={3}>
          {invoice.member && (
            <>
              <Typography variant='h6' sx={{ fontWeight: 600, fontSize: 16 }}>
                {invoice.member.other === true ? t(otherLabel) : t('invoice:Member')}:
              </Typography>
              <Typography variant='h6' fontSize={16}>
                <Link
                  to={`${invoice.member.other === true ? RoutesEnum.MemberOtherContactDetails : RoutesEnum.MemberDetails}/${
                    invoice.member?.member_id
                  }`}
                >{`${invoice.member?.firstName} ${invoice.member.lastName}`}</Link>
              </Typography>
              <MemberDetail detail={invoice.member.address} />
              <MemberDetail detail={invoice.member.addressOther} />
              <MemberDetail detail={invoice.member.coAddress} />
              <MemberDetail detail={invoice.member.postNr} />
              <MemberDetail detail={invoice.member.postAddress} />
              <MemberDetailLink icon={<Email sx={{ mr: 1 }} />} linkPrefix='mailto:' details={[invoice.member.email || '']} />
              {(invoice.member.phone || invoice.member.phoneOther) && (
                <MemberDetailLink
                  icon={<Phone sx={{ mr: 1 }} />}
                  linkPrefix='tel:'
                  details={[invoice.member.phoneOther ?? '', invoice.member.phone ?? '']}
                />
              )}
            </>
          )}
          {!invoice.member && invoice.donor && (
            <>
              <Typography variant='h6' sx={{ fontWeight: 600, fontSize: 16 }}>
                {t('invoice:Donor')}:
              </Typography>
              <Typography variant='h6' fontSize={16}>
                <Link to={`${RoutesEnum.DonorsDetail}/${invoice.donor.id}`}>{invoice.donor.name}</Link>
              </Typography>
              {invoice.donor.email && <MemberDetailLink icon={<Email sx={{ mr: 1 }} />} linkPrefix='mailto:' details={[invoice.donor.email]} />}
              {invoice.donor.phone && <MemberDetailLink icon={<Phone sx={{ mr: 1 }} />} linkPrefix='tel:' details={[invoice.donor.phone]} />}
            </>
          )}
        </Grid>
      </GridWrapper>
      {invoice.rows && invoice.rows?.length > 0 && (
        <>
          <Grid item minHeight={0} xs={12} mt={4}>
            <Divider />
          </Grid>
          <InvoiceRowsTable invoice={invoice} />
        </>
      )}
      {/* Kommenterar ut fakturatext tills vidare enligt KH 2023-03-30 */}
      {/* <Grid item xs={12}>
      <ExpandableInvoiceText sendings={invoice?.sendings ?? []} />
    </Grid> */}
    </ContentSection>
  );
};
